import i18n from 'i18next';
import { useTranslation, initReactI18next } from 'react-i18next';
import enJSON from '@/utils/translation/JSONs/en.json';
import esJSON from '@/utils/translation/JSONs/es.json';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enJSON },
      es: { translation: esJSON },
    },
    // lng: navigator.language.split("-")[0],
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
